import filter from 'lodash/filter';
import minBy from 'lodash/minBy';
import some from 'lodash/some';
import find from 'lodash/find';

export function getMinPriceInfo(dealInfo) {
  const enabledDealInfo = filter(dealInfo, { enabled: true });
  if (!enabledDealInfo.length) {
    return null;
  }

  return minBy(enabledDealInfo, 'price');
}

export function hasEnabledPriceInfo(dealInfo) {
  return some(dealInfo, { enabled: true });
}

function buildGetPriceInfo(type) {
  const query = {
    enabled: true,
    type,
  };

  return function (dealInfo) {
    return find(dealInfo, query) || null;
  };
}

export const getSubscriptionPriceInfo = buildGetPriceInfo('subscription');
export const getSalePriceInfo = buildGetPriceInfo('sale');
export const getRentPriceInfo = buildGetPriceInfo('rent');



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/utils/deal-info-helpers.js